import { useCallback } from 'react';

interface UseCancelSelectOnBlankClickOptions {
  /** 是否启用点击逻辑 */
  enabled: boolean;
  /** 是否阻止点击（如有弹窗打开） */
  blocked?: boolean;
  /** 点击回调 */
  onClick: () => void;
}

/**
 * 点击空白区域触发回调
 * @param options 配置项
 * @returns 点击事件处理函数
 */
export function useCancelSelectOnBlankClick({
  enabled,
  blocked = false,
  onClick,
}: UseCancelSelectOnBlankClickOptions) {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (!enabled) return;
      if (blocked) return;

      onClick();
    },
    [enabled, blocked, onClick]
  );

  return {
    onClick: handleClick,
  };
}
